import { useSelector } from 'react-redux';
import { getEnv } from './selectors';

/** Tries to get the window.location.href when in the browser but falls back to
 *  the `environment.requestUrl` from da-react-app on the server */
export function useCurrentUrl(): string | undefined {
  const { requestUrl: environmentRequestUrl } = useSelector(getEnv);
  return typeof window === 'undefined'
    ? environmentRequestUrl
    : window.location.href;
}
